import { __decorate, __metadata } from "tslib";
import { Guid } from "guid-typescript";
import { VuexModule, Module, getModule, Action, Mutation } from "vuex-module-decorators";
import { plainToClass } from "class-transformer";
import { Engagement, IEngagement } from "../models/engagements/engagement";
import { IEngagementBase } from "../models/engagements/engagementBase";
import { EngagementRollUp } from "../models/engagements/engagementRollup";
import EngagementStage from "../models/engagements/engagementStage";
import EngagementActivityNote, { IEngagementActivityNote } from "../models/engagements/engagementActivityNote";
import { EngagementActivityDocModel, IEngagementActivityDoc } from "../models/engagements/engagementActivityDoc";
import store from "@/store";
import service from "../../services/api.service";
import { IEngagementActivityAction } from "../models/engagements/engagementActivityAction";
import { IEngagementActivity, EngagementActivity } from "../models/engagements/engagementActivity";
import { getTenantId } from "@/store/helper";
let EngagementsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    let EngagementsModule = class EngagementsModule extends VuexModule {
        constructor() {
            super(...arguments);
            // STATE
            this.collection = [];
            this.model = null;
            this.template = [];
            this.projectTypes = [];
            this.apiNode = "engagement";
        }
        // GETTERS
        get stageData() {
            return (stageId) => {
                this.model.stages.find((stage) => stage.stageId === stageId);
            };
        }
        // ACTIONS
        async GetEngagements() {
            var url = `${getTenantId()}/${this.apiNode}/rollup`;
            let { data } = await service.get(url);
            if (data) {
                this.SetEngagements(plainToClass(EngagementRollUp, data.engagementRollups));
                return data;
            }
        }
        async GetEngagement(engagementId) {
            var url = `${getTenantId()}/${this.apiNode}/` + engagementId;
            let { data } = await service.get(url);
            if (data) {
                this.SetEngagement(plainToClass(Engagement, data.engagement));
                this.SetProjectEngagementTypes(data.projectTypes);
                return data;
            }
        }
        async CreateNewEngagement(clientEngagement) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, clientEngagement);
            if (data) {
                this.AddEngagement(plainToClass(EngagementRollUp, data.engagementRollup));
                return data;
            }
        }
        async UpdateEngagement(engagement) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.put(url, engagement);
            if (data) {
                this.model.projectType = data.clientEngagement.projectType;
                return data;
            }
        }
        async SaveTenantEngagementStage(engagementStageDetails) {
            var url = `${getTenantId()}/${this.apiNode}/` + engagementStageDetails[0] + "/clientEngagementStage";
            let { data } = await service.post(url, engagementStageDetails[1]);
            if (data) {
                this.AddOrEditStageInEngagement([engagementStageDetails[0], plainToClass(EngagementStage, data.clientEngagementStage)]);
                return data;
            }
        }
        async SaveTenantEngagementActivity(engagementActivityDetails) {
            var url = `${getTenantId()}/${this.apiNode}/` + engagementActivityDetails[0] + "/clientEngagementStage/" + engagementActivityDetails[1];
            let { data } = await service.post(url, engagementActivityDetails[2]);
            if (data) {
                this.AddOrEditActivityInStage([engagementActivityDetails[0], engagementActivityDetails[1], plainToClass(EngagementActivity, data.clientEngagementActivity)]);
                return data;
            }
        }
        async DeleteTenantEnagagementStage(stageId) {
            var url = `${getTenantId()}/${this.apiNode}/stage/` + stageId;
            let { data } = await service.delete(url);
            if (data) {
                this.DeleteStageFromTenantEngagement(data.stageId);
                return data;
            }
        }
        async DeleteTenantEnagagementActivity(activityId) {
            var url = `${getTenantId()}/${this.apiNode}/activity/` + activityId;
            let { data } = await service.delete(url);
            if (data) {
                this.DeleteActivityFromTenantEngagementStage(data.activityId);
                return data;
            }
        }
        async DeleteTenantEnagagementActivityAction(action) {
            var actionId = action.id;
            var url = `${getTenantId()}/${this.apiNode}/action/` + actionId;
            let { data } = await service.delete(url);
            if (data) {
                this.DeleteActionFromTenantEngagementActivity(action);
                return data;
            }
        }
        async MarkTenantEnagagementActivity(activity) {
            var url = `${getTenantId()}/${this.apiNode}/activity/`;
            let { data } = await service.put(url, activity);
            if (data) {
                this.MarkEngagementActivity(data.activity);
                return data;
            }
        }
        async SaveActivityNotes(activityNote) {
            var url = `${getTenantId()}/${this.apiNode}/activitynote`;
            let { data } = await service.post(url, activityNote);
            if (data) {
                this.AddNotesToTenantEngagementActivity(plainToClass(EngagementActivityNote, data.clientEngagementActivityNote));
                return data;
            }
        }
        async SaveActivityDocument(activityDoc) {
            var url = `${getTenantId()}/${this.apiNode}/activitydoc`;
            let { data } = await service.post(url, activityDoc);
            if (data) {
                this.AddDocumentToTenantEngagementActivity(data.clientEngagementActivityDoc);
                return data;
            }
        }
        async SaveActivityAction(activityAction) {
            var url = `${getTenantId()}/${this.apiNode}/action`;
            let { data } = await service.post(url, activityAction);
            if (data) {
                this.AddActionToTenantEngagementActivity(data.clientEngagementActivityAction);
                return data;
            }
        }
        async DeleteActivityDocument(document) {
            var documentId = document.id;
            var url = `${getTenantId()}/${this.apiNode}/activitydoc/` + documentId;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveDocumentFromTenantEngagementActivity(document);
                return data;
            }
        }
        // MUTATIONS
        SetEngagement(engagement) {
            this.model = engagement;
        }
        SetProjectEngagementTypes(engagementType) {
            this.projectTypes = engagementType;
        }
        SetEngagements(engagements) {
            this.collection = engagements;
        }
        SetEngagementTemplate(configurations) {
            this.template = configurations;
        }
        AddEngagement(engagement) {
            this.collection.push(engagement);
        }
        AddOrEditActivityInStage(engagementActivity) {
            var currentStage = this.model.stages.find((x) => x.stageId == engagementActivity[1]);
            var existingActivity = currentStage.activities.find((x) => x.activityId == engagementActivity[2].activityId);
            if (existingActivity === null || existingActivity === undefined) {
                currentStage.activities.push(engagementActivity[2]);
            }
            else {
                existingActivity.activityDesc = engagementActivity[2].activityDesc;
                existingActivity.isTenantVisible = engagementActivity[2].isTenantVisible;
                existingActivity.baseline = engagementActivity[2].baseline;
                existingActivity.threshold = engagementActivity[2].threshold;
                existingActivity.actuals = engagementActivity[2].actuals;
            }
        }
        DeleteActivityFromTenantEngagementStage(activityId) {
            var stage = this.model.stages.find((x) => x.activities.find((x) => x.activityId == activityId));
            const index = stage.activities
                .map(function (array) {
                return array.activityId;
            })
                .indexOf(activityId, 0);
            if (index > -1) {
                stage.activities.splice(index, 1);
            }
        }
        DeleteActivityFromEngagementStage(activityId) {
            var stage = this.template.find((x) => x.activities.find((x) => x.activityId == activityId));
            const index = stage.activities
                .map(function (array) {
                return array.activityId;
            })
                .indexOf(activityId, 0);
            if (index > -1) {
                stage.activities.splice(index, 1);
            }
        }
        AddOrEditStageInEngagement(engagementStage) {
            var theStage = engagementStage[1];
            var existingStage = this.model.stages.find((x) => x.stageId == theStage.stageId);
            if (existingStage === null || existingStage === undefined) {
                theStage.activities = [];
                this.model.stages.push(theStage);
            }
            else {
                existingStage.stageName = theStage.stageName;
                existingStage.isTenantVisible = theStage.isTenantVisible;
                existingStage.description = theStage.description;
            }
        }
        MarkEngagementActivity(activity) {
            this.model.stages.find((x) => x.activities.find((x) => x.activityId == activity.activityId)).activities.filter((x) => x.activityId == activity.activityId)[0].isDone = activity.isDone;
            //var activity = stage.activities.filter(x => x.activityId == activityId);
            //activity[0].isDone = true;
        }
        AddStageToEngagement(engagementStage) {
            var newStage = engagementStage[1];
            newStage.activities = [];
            this.model.stages.push(newStage);
        }
        DeleteStageFromTenantEngagement(stageId) {
            const index = this.model.stages
                .map(function (array) {
                return array.stageId;
            })
                .indexOf(stageId, 0);
            if (index > -1) {
                var stage = this.model.stages.splice(index, 1);
                stage;
            }
            this.model.stages;
        }
        DeleteStageFromEngagementStage(stageId) {
            const index = this.template
                .map(function (array) {
                return array.stageId;
            })
                .indexOf(stageId, 0);
            if (index > -1) {
                var stage = this.template.splice(index, 1);
            }
        }
        AddNotesToTenantEngagementActivity(engagementActivityNote) {
            engagementActivityNote;
            var stage = this.model.stages.find((x) => x.activities.find((x) => x.activityId == engagementActivityNote.activityId));
            stage;
            var activity = stage.activities.find((x) => x.activityId == engagementActivityNote.activityId);
            activity.notes = engagementActivityNote.notes;
        }
        AddDocumentToTenantEngagementActivity(tenantEngagementActivityDoc) {
            var stage = this.model.stages.find((x) => x.activities.find((x) => x.activityId == tenantEngagementActivityDoc.activityId));
            var activity = stage.activities.find((x) => x.activityId == tenantEngagementActivityDoc.activityId);
            activity.docs.push(tenantEngagementActivityDoc);
        }
        AddActionToTenantEngagementActivity(tenantEngagementActivityAction) {
            var stage = this.model.stages.find((x) => x.activities.find((x) => x.activityId == tenantEngagementActivityAction.activityId));
            var activity = stage.activities.find((x) => x.activityId == tenantEngagementActivityAction.activityId);
            activity.actions.push(tenantEngagementActivityAction);
        }
        RemoveDocumentFromTenantEngagementActivity(tenantEngagementActivityDoc) {
            var stage = this.model.stages.find((x) => x.activities.find((x) => x.activityId == tenantEngagementActivityDoc.activityId));
            var activity = stage.activities.find((x) => x.activityId == tenantEngagementActivityDoc.activityId);
            const index = activity.docs
                .map(function (array) {
                return array.id;
            })
                .indexOf(tenantEngagementActivityDoc.id, 0);
            if (index > -1) {
                activity.docs.splice(index, 1);
            }
        }
        DeleteActionFromTenantEngagementActivity(tenantEngagementActivityAction) {
            var stage = this.model.stages.find((x) => x.activities.find((x) => x.activityId == tenantEngagementActivityAction.activityId));
            var activity = stage.activities.find((x) => x.activityId == tenantEngagementActivityAction.activityId);
            const index = activity.actions
                .map(function (array) {
                return array.id;
            })
                .indexOf(tenantEngagementActivityAction.id, 0);
            if (index > -1) {
                activity.actions.splice(index, 1);
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], EngagementsModule.prototype, "GetEngagements", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Guid !== "undefined" && Guid) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], EngagementsModule.prototype, "GetEngagement", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IEngagementBase !== "undefined" && IEngagementBase) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], EngagementsModule.prototype, "CreateNewEngagement", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof IEngagementBase !== "undefined" && IEngagementBase) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], EngagementsModule.prototype, "UpdateEngagement", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], EngagementsModule.prototype, "SaveTenantEngagementStage", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], EngagementsModule.prototype, "SaveTenantEngagementActivity", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof Guid !== "undefined" && Guid) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], EngagementsModule.prototype, "DeleteTenantEnagagementStage", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof Guid !== "undefined" && Guid) === "function" ? _m : Object]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], EngagementsModule.prototype, "DeleteTenantEnagagementActivity", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof IEngagementActivityAction !== "undefined" && IEngagementActivityAction) === "function" ? _p : Object]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], EngagementsModule.prototype, "DeleteTenantEnagagementActivityAction", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof IEngagementActivity !== "undefined" && IEngagementActivity) === "function" ? _r : Object]),
        __metadata("design:returntype", typeof (_s = typeof Promise !== "undefined" && Promise) === "function" ? _s : Object)
    ], EngagementsModule.prototype, "MarkTenantEnagagementActivity", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_t = typeof IEngagementActivityNote !== "undefined" && IEngagementActivityNote) === "function" ? _t : Object]),
        __metadata("design:returntype", typeof (_u = typeof Promise !== "undefined" && Promise) === "function" ? _u : Object)
    ], EngagementsModule.prototype, "SaveActivityNotes", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_v = typeof EngagementActivityDocModel !== "undefined" && EngagementActivityDocModel) === "function" ? _v : Object]),
        __metadata("design:returntype", typeof (_w = typeof Promise !== "undefined" && Promise) === "function" ? _w : Object)
    ], EngagementsModule.prototype, "SaveActivityDocument", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_x = typeof IEngagementActivityAction !== "undefined" && IEngagementActivityAction) === "function" ? _x : Object]),
        __metadata("design:returntype", typeof (_y = typeof Promise !== "undefined" && Promise) === "function" ? _y : Object)
    ], EngagementsModule.prototype, "SaveActivityAction", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_z = typeof IEngagementActivityDoc !== "undefined" && IEngagementActivityDoc) === "function" ? _z : Object]),
        __metadata("design:returntype", typeof (_0 = typeof Promise !== "undefined" && Promise) === "function" ? _0 : Object)
    ], EngagementsModule.prototype, "DeleteActivityDocument", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_1 = typeof IEngagement !== "undefined" && IEngagement) === "function" ? _1 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "SetEngagement", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "SetProjectEngagementTypes", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "SetEngagements", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "SetEngagementTemplate", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_2 = typeof EngagementRollUp !== "undefined" && EngagementRollUp) === "function" ? _2 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddEngagement", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddOrEditActivityInStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_3 = typeof Guid !== "undefined" && Guid) === "function" ? _3 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "DeleteActivityFromTenantEngagementStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_4 = typeof Guid !== "undefined" && Guid) === "function" ? _4 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "DeleteActivityFromEngagementStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddOrEditStageInEngagement", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_5 = typeof IEngagementActivity !== "undefined" && IEngagementActivity) === "function" ? _5 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "MarkEngagementActivity", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddStageToEngagement", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_6 = typeof Guid !== "undefined" && Guid) === "function" ? _6 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "DeleteStageFromTenantEngagement", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_7 = typeof Guid !== "undefined" && Guid) === "function" ? _7 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "DeleteStageFromEngagementStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddNotesToTenantEngagementActivity", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_8 = typeof IEngagementActivityDoc !== "undefined" && IEngagementActivityDoc) === "function" ? _8 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddDocumentToTenantEngagementActivity", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_9 = typeof IEngagementActivityAction !== "undefined" && IEngagementActivityAction) === "function" ? _9 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "AddActionToTenantEngagementActivity", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_10 = typeof IEngagementActivityDoc !== "undefined" && IEngagementActivityDoc) === "function" ? _10 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "RemoveDocumentFromTenantEngagementActivity", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_11 = typeof IEngagementActivityAction !== "undefined" && IEngagementActivityAction) === "function" ? _11 : Object]),
        __metadata("design:returntype", void 0)
    ], EngagementsModule.prototype, "DeleteActionFromTenantEngagementActivity", null);
    EngagementsModule = __decorate([
        Module({ dynamic: true, store: store, name: "engagements", namespaced: true })
    ], EngagementsModule);
    return EngagementsModule;
})();
export default getModule(EngagementsModule);
